import { ActionEnum } from '../enum/action.enum';
import { action } from 'mobx';
import { ActionFunction } from '../interface/action/action-function.type';
import { IRoutePayload } from '../interface/action/route-payload.interface';
import { getWebDocByHash } from '../util/action/type/get-web-doc-by-hash-action.util';
import { decodeQuery } from '../util/url/decode-query.util';

export const loadDynamicWebDocument$: ActionFunction<IRoutePayload> = (action$, {state}) => {
  return action$
    .type(ActionEnum.LOAD_WEB_DOC_ROUTE)
    .map(action(action((payload: IRoutePayload) => {
      state.activeDesign.loadParams.params = payload.match.params;
      const {templateId} = payload.match.params;
      const {cipher} = decodeQuery(payload.location.search);
      return getWebDocByHash(templateId, decodeURIComponent(cipher));
    })));
};

export default {
  actions: [ loadDynamicWebDocument$ ]
};
